import React from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {get} from 'lodash';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import {Icon} from '@material-ui/core';
import HistoryDialog from '../../components/HistoryDialog';
import SwipeableTabs, {SwipeableTab} from '../../components/SwipeableTabs';
import SdCardStatus from './SdCardStatus';
import DVRErrorsPanel from './DVRErrorsPanel';
import DVRSnapshots from '../../DVRSnapshots/component/DVRSnapshots';
import DVRSnapshotsCarousel from '../../DVRSnapshots/component/DVRSnapshotsCarousel';
import DVRInfoTable from './DVRInfoTable';
import DVRHealthStatus from '../DVRHealthStatus';

export default class MobileDVRCardDetail extends React.PureComponent {

  static propTypes = {
    id: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    alertsCheck: PropTypes.func.isRequired
  }

  getDvrStatus() {
    const {substatus} = this.props;
    return DVRHealthStatus.forSubstatus(substatus);
  }

  render() {
    const {
      id,
      open,
      onClose,
      substatus,
      serialNo,
      machineType,
      dvrSnapshots,
      customer,
      alertsCheck
    } = this.props;

    const dvrStatus = this.getDvrStatus();
    const health = get(this.props, 'health', {});
    const pairingMethod = get(customer, 'data.dvrPairing.method', 'dsn');

    return (
      <HistoryDialog
        id={id}
        fullScreen
        open={open}
        onClose={onClose}
      >
        <AppBar
          position="static"
          color="default"
          className={dvrStatus.getMobileTitleCssClass()}
        >
          <Toolbar>
            <IconButton id="backButton" onClick={onClose}>
              <Icon>arrow_back</Icon>
            </IconButton>

            <Typography id="dvrStatusTitle" variant="title" color="inherit">
              {dvrStatus.getTitle()}
            </Typography>
          </Toolbar>
        </AppBar>

        <SwipeableTabs
          tabsProps={{
            className: 'dvrcard__tabs-mobile',
            variant: 'fullWidth'
          }}
          swipeableViewsProps={{
            className: 'dvrcard__tabs'
          }}
        >
          <SwipeableTab
            id="healthTab"
            tabLabel={I18n.t('page.dvrHealth.dialog.tabs.health')}
            tabProps={{
              className: 'dvrcard__tab-mobile'
            }}
            containerProps={{
              className: 'dvrcard__tab-cont-mobile'
            }}
          >
            <Paper className="paper-cont">
              {!health.sdcard && !health.alerts &&
                <div>
                  <Grid
                    item
                    md={12}
                    id="noSdCardMessage"
                    className="dvrcard__infocont"
                  >
                    <Icon className="dvrcard__info-icon">info</Icon>
                    <span>
                      {I18n.t('page.dvrHealth.dialog.sdCardHealthNotAvailable')}
                    </span>
                  </Grid>
                </div>
              }

              {health.sdcard &&
                <div className="sdcard__cont">
                  <SdCardStatus
                    showHeader={false}
                    sdcard={health.sdcard}
                    alertsCheck={alertsCheck}
                  />
                </div>
              }

              {health.alerts &&
                <DVRErrorsPanel substatus={substatus} alerts={health.alerts} pairingMethod={pairingMethod} />
              }
            </Paper>
          </SwipeableTab>

          <SwipeableTab
            id="cameraTab"
            tabLabel={I18n.t('page.dvrHealth.dialog.tabs.cameras')}
            tabProps={{
              className: 'dvrcard__tab-mobile'
            }}
            containerProps={{
              className: 'dvrcard__tab-cont-mobile'
            }}
          >
            <DVRSnapshots serialNumber={serialNo} machineType={machineType} />
          </SwipeableTab>

          <SwipeableTab
            id="dvrInfoTab"
            tabLabel={I18n.t('page.dvrHealth.dialog.tabs.dvrInfo')}
            tabProps={{
              className: 'dvrcard__tab-mobile'
            }}
            containerProps={{
              className: 'dvrcard__tab-cont-mobile'
            }}
          >
            <Paper className="paper-cont">
              <DVRInfoTable tableClassName="dvrcard__table-mobile" {...this.props} />
            </Paper>
          </SwipeableTab>
        </SwipeableTabs>

        <Dialog
          open={this.props.dvrSnapshotsCarouselOpened === true}
          classes={{
            paperWidthSm: 'dvrcard__camera-view-mobile-paper'
          }}
        >
          <DialogContent className="dvrcard__camera-view-mobile">
            <DVRSnapshotsCarousel machineType={machineType} {...dvrSnapshots} />
          </DialogContent>
        </Dialog>
      </HistoryDialog>
    );
  }
}
